<template>
  <div class="public-interactions-event-view-body">
    <img
      v-if="image"
      :src="mixinGetFilePath(image, 'O')"
      alt=""
      class="public-interactions-display-image"
    />
    <div class="public-interactions-content">
      <div v-if="title" class="public-interactions-title ql-editor">
        {{ title }}
      </div>
      <div
        v-if="description"
        v-html="descriptionExpanded ? description : shortText(description, 100)"
        class="public-interactions-description ql-editor"
      ></div>
      <div
        class="public-interactions-see-more ql-editor"
        v-if="description && strippedHtml(description).length > 100"
      >
        <a href @click.prevent="descriptionExpanded = !descriptionExpanded">{{
          descriptionExpanded ? 'See Less' : 'See More'
        }}</a>
      </div>
      <div class="public-interactions-expand-button">
        <span
          v-if="totalMatchedEvent"
          @click="updateFullTab"
          class="public-interactions-expand-button-content"
        >
          <md-icon class="public-interactions-icon">remove_red_eye</md-icon>
          <span class="public-interactions-count">{{ totalMatchedEvent }}</span>
          <span class="public-interactions-expand-button-text">
            Event record(s) available to view
          </span>
        </span>
        <span
          class="public-interactions-expand-button-content"
          @click="updateFullTab"
          v-else
        >
          {{ isFullCompactCollapsed ? 'Tap to close' : 'Tap to explore' }}
        </span>
      </div>
    </div>

    <div ref="mainTab" tabindex="-1">
      <div v-if="isFullCompactCollapsed">
        <div
          v-for="(element, index) in elementItems"
          :key="index"
          class="public-interactions-event-view-item"
        >
          <public-interactions-event-view-item
            :item="element"
            :previousTransportationMethod="
              index > 0 ? elementItems[index - 1].transportationMethod : null
            "
            :isLast="index === elementItems.length - 1"
            :isFirst="index === 0"
          ></public-interactions-event-view-item>
        </div>
        <div class="text-align--center">
          <md-button class="md-simple" @click="updateFullTab">
            <img src="/img/icons/event_view_up_arrow.png" style="width: 34px" />
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PublicInteractionsEventViewItem from './publicInteractionsEventViewItem';

export default {
  components: {
    PublicInteractionsEventViewItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    valueChain: {
      type: Object,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
  computed: {
    elementItems() {
      let elements = [];
      if (
        this.valueChain &&
        this.valueChain.elements &&
        this.valueChain.elements.length
      ) {
        elements = this.valueChain.elements
          .filter((item) => !!item.enabled)
          .map((elm) => {
            const interactions = this.items.filter(
              (interaction) =>
                interaction.valueChainElement &&
                interaction.valueChainElement.id === elm.id,
            );
            elm.interactions = interactions;
            return elm;
          });
      }

      return elements;
    },
    notMatchedItems() {
      const elementsIds = this.elementItems.map((elm) => elm.id);
      const notMatchedInteractions = this.items.filter((interaction) => {
        const elementId = interaction.valueChainElement
          ? interaction.valueChainElement.id
          : null;
        return !elementsIds.includes(elementId);
      });

      return {
        name: 'Events Not Matched',
        interactions: notMatchedInteractions,
      };
    },
    totalMatchedEvent() {
      return this.items.length - this.notMatchedItems.interactions.length;
    },
  },
  data() {
    return {
      isFullCompactCollapsed: false,
      descriptionExpanded: false,
    };
  },
  methods: {
    updateFullTab() {
      this.isFullCompactCollapsed = !this.isFullCompactCollapsed;
      this.$nextTick(function () {
        if (this.isFullCompactCollapsed) {
          window.scrollBy({
            top: 400,
            behavior: 'smooth',
          });
        } else {
          window.scrollBy({
            top: -400,
            behavior: 'smooth',
          });
          this.$refs.mainTab.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-interactions.scss';
</style>
